import React from 'react';
import Radium from 'radium';
import { func } from 'prop-types';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';

import stylesJS from './styles';
import styles from './styles.module.scss';

const CustomBanner = ({ onClick }) => (
  <div style={stylesJS.innerContainer}>
    <div style={stylesJS.textContainer}>
      <div className={styles.flex}>
        <UTLabel small extrabold primary uppercase>
          {message('Banner:banner1')}
        </UTLabel>
        <UTLabel small primary uppercase>
          {message('Banner:banner2')}
        </UTLabel>
      </div>
      <div className={styles.flex}>
        <UTLabel small primary uppercase>
          {message('Banner:banner3')}
        </UTLabel>
        <UTLabel small extrabold primary>
          {message('Banner:banner4').toUpperCase()}
        </UTLabel>
      </div>
    </div>
    <UTButton onPress={onClick} className={styles.bannerButton} secondary>
      {message('Banner:register')}
    </UTButton>
  </div>
);

CustomBanner.propTypes = {
  onClick: func
};

export default Radium(CustomBanner);
